import api from './api';

// Shake-to-report: super-admin schránka hlásení problémov z mobilnej appky.
// Endpointy sú chránené role='admin' (viď backend report.routes.js).

const getReports = (status) => {
    // status: 'open' | 'resolved' | undefined (všetky)
    return api.get('/admin/reports', { params: status ? { status } : {} });
};

const getOpenCount = () => {
    return api.get('/admin/reports/count');
};

// note: voliteľná poznámka, ktorá sa pošle používateľovi do AI chatu spolu s "vyriešené".
const resolveReport = (id, note) => {
    return api.put(`/admin/reports/${id}/resolve`, { note: note || '' });
};

const ReportService = {
    getReports,
    getOpenCount,
    resolveReport,
};

export default ReportService;
